import Vue from 'vue'
import Home from './Home.vue'
import VueLazy from 'vue-lazyload'
import store from '../../store'
import i18n from '../../i18n/i18n'
import storejs from 'storejs'
import '../../components/loading/index'
import {
    DatePicker, Select, Option, Dropdown, Loading,
    DropdownMenu, DropdownItem, Input, Form,
    FormItem, Tabs, TabPane, Notification, Message, MessageBox
} from "element-ui";
import request from '../../lib/requests'
import '../../sass/_resset.scss'
import '../../sass/fonts/iconfont'
import "../../sass/fonts/iconfont.css";
import '../../sass/_buttons.scss'
import '../../sass/_elementui.scss'
import '../../sass/_normalize.scss'

Vue.config.productionTip = false;

Vue.prototype.$req = request;
Vue.prototype.$local = storejs;

Vue.use(DatePicker)
Vue.use(Select).use(Option)
Vue.use(Dropdown).use(DropdownMenu).use(DropdownItem)
Vue.use(Form).use(FormItem).use(Input)
Vue.use(Tabs).use(TabPane)
Vue.use(Loading.directive);

Vue.prototype.$notify = Notification
Vue.prototype.$msg = Message
Vue.prototype.$confirm = MessageBox.confirm;

Vue.use(VueLazy, {
    error: require('../../assets/images/default@2x.png'),
    loading: require('../../assets/images/default@2x.png')
})

new Vue({
    el: '#app',
    template: '<Home/>',
    i18n,
    store,
    components: { Home },
});


// WEBPACK FOOTER //
// ./src/views/home/index.js